import type { BaseCardMetaMode, BaseWithRelations } from "@/types/base";

import styles from "./BaseGrid.module.css";
import { BaseCardServer } from "../BaseCard";

interface Props {
  bases: BaseWithRelations[];
  showTime?: boolean;
  showMeta?: BaseCardMetaMode;
  showImage?: boolean;
  variant?: "default" | "featured";
  mobileBleed?: boolean;
  responsiveMode?: "default" | "homepage" | "levelPreview" | "single";
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(" ");
}

function getResponsiveClass(responsiveMode: Props["responsiveMode"]) {
  if (responsiveMode === "homepage") return styles.homepage;
  if (responsiveMode === "levelPreview") return styles.levelPreview;
  if (responsiveMode === "single") return styles.single;
  return styles.defaultResponsive;
}

export default function BaseGrid({
  bases,
  showTime = false,
  showMeta = false,
  showImage = true,
  variant = "default",
  mobileBleed = true,
  responsiveMode = "default",
}: Props) {
  if (!bases || bases.length === 0) return null;

  const variantClass =
    variant === "featured" ? styles.featured : styles.default;
  const responsiveClass = getResponsiveClass(responsiveMode);

  const shouldBleed = mobileBleed && bases.length >= 2;
  const isFeaturedMobileTwoUp = variant === "featured" && shouldBleed;

  return (
    <>
      <div
        className={cx(
          styles.grid,
          variantClass,
          responsiveClass,
          shouldBleed && styles.bleedMobile
        )}
      >
        {bases.map((base) => (
          <BaseCardServer
            key={base.id}
            base={base}
            showTime={showTime}
            showMeta={showMeta}
            showImage={showImage}
            noRadiusOnMobile={isFeaturedMobileTwoUp}
            compactMobileInfo={isFeaturedMobileTwoUp}
          />
        ))}
      </div>
    </>
  );
} 